import "../css/Title.css";

export default function Title({ title, subtitle }) {
    return (
        <div className="title-box">
            <div className="title">{title}</div>
            <div className="title-subtitle">{subtitle}</div>
        </div>
    );
}
